module.exports = "/assets/data/68a4075e699566cffafa3bde83bea18e-NE38.data.json";